import { render, staticRenderFns } from "./ResultStudentList.vue?vue&type=template&id=ce82459e&scoped=true&"
import script from "./ResultStudentList.vue?vue&type=script&lang=ts&"
export * from "./ResultStudentList.vue?vue&type=script&lang=ts&"
import style0 from "./ResultStudentList.vue?vue&type=style&index=0&id=ce82459e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce82459e",
  null
  
)

export default component.exports